import { React, useContext } from "react";
import "./UpgradeModal.css";
import { LocationContext } from "../../reducers/LocationContext";


export default function UpgradeModal({ show, onClose }) {
    const { countryCode } = useContext(LocationContext);
    if (!show) return null;

    const handleUpgrade = () => {
        const route = countryCode === "IN" ? "/subscribe" : "/subscription";
        window.location.href = route;
    };

    return (
        <div className="upgrade-overlay">
            <div className="upgrade-modal">
                <button className="close-btn" onClick={onClose}>×</button>
                <h2>You’re on the Free Tier</h2>
                <p>You currently have access to the following features:</p>

                <ul className="features-list">
                    <li>✔ You have only two practice per day</li>
                    {/* <li>✔ Access basic templates</li>
                    <li>✔ Limited cloud storage</li> */}
                </ul>

                <div className="action-buttons">
                    <button className="later-btn" onClick={onClose}>Maybe Later</button>
                    <button className="upgrade-btn"
                        onClick={handleUpgrade}
                    >
                        Upgrade Now
                    </button>
                </div>
            </div>
        </div>
    );
}
